/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHealth: {
  name: 'health';
  data: string;
} = {
  name: 'health',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M557.018 198.413H413.581V54.979c0-19.804-16.054-35.861-35.861-35.861H234.282c-19.807 0-35.861 16.057-35.861 35.861v143.434H54.987c-19.807 0-35.861 16.057-35.861 35.861v143.438c0 19.807 16.057 35.861 35.861 35.861h143.434v143.438c0 19.807 16.057 35.861 35.861 35.861H377.72c19.807 0 35.861-16.057 35.861-35.861V413.573h143.438c19.804 0 35.858-16.054 35.861-35.861V234.274c0-19.807-16.058-35.861-35.862-35.861z"/></svg>`,
};
